import { showCaptcha } from "state/actionCreators/networkError";

const createCaptchaHandler = (store) => (error) =>
  store.dispatch(showCaptcha(error));

export default createCaptchaHandler;
